{
    "coordinates": [
        54.513999192328555,
        -120.74640695942995
    ],
    "tooltip": "Sulphur Mountain",
    "title": "Sulphur Mountain Formation",
    "country": "Canada",
    "period": "Triassic"
}
